import SelectTableFilter from 'components/atoms/select-table-filter'
import RejectReasonBadge from 'domains/merchant-inbound-item-reject/atoms/reject-reason-badge'
import { REJECT_REASON } from 'domains/merchant-inbound-item-reject/constants'
import React from 'react'
import RowButton from 'components/atoms/row-button'

/**
 * Merchant Inbound Item Reject Table Columns
 */
const merchantInboundItemRejectTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick,
  isButtonDisabled
}) => {

  // eslint-disable-next-line react/prop-types
  const RejectReasonFilter = ({ column }) => {
    const options = Object.keys(REJECT_REASON).map((key) => (
      {
        label : REJECT_REASON[key],
        value : REJECT_REASON[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  const RejectReasonCell = (row) => <RejectReasonBadge reject_reason={ row.cell.value } />

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {
    // eslint-disable-next-line react/prop-types
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        // eslint-disable-next-line react/prop-types
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        text={ buttonText }
        disabled={ disabled }
      />
    )

  }

  return (
    [
      {
        Header  : 'Merchant Inbound Item Reject',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header   : 'Product Info',
            accessor : 'product_info'
          },
          {
            Header   : <>Reject <br/> Reason</>,
            accessor : 'reject_reason',
            id       : 'reject_reason',
            Cell     : RejectReasonCell,
            Filter   : RejectReasonFilter
          },
          {
            Header         : 'Reject Note',
            accessor       : 'reject_note',
            disableFilters : true
          },
          {
            Header         : 'Rejected By',
            accessor       : 'rejected_by.name',
            disableFilters : true
          },
          {
            Header : 'Action',
            id     : 'action',
            Cell   : ActionCell
          }
        ]
      }
    ]
  )
}

export default merchantInboundItemRejectTableColumns